import { useContext } from 'react';

import { FlowConfigContext } from '#client/App/FlowConfigProvider';

/**
 * Custom hook to retrieve and memoize flow configuration.
 *
 * @returns {import('#client/App/FlowConfigProvider').FlowConfigContextValue} - Memoized object.
 */
export default function useFlowConfig() {
  const context = useContext(FlowConfigContext);
  if (!context) {
    return {}; // Allow this hook to be used conditionally outside of a provider
  }
  return context;
}
